<template>
  <div>
    <PageHeader title="Profile"></PageHeader>
    <v-container class="page-bottom">
      <v-row>
        <v-col class="pa-0">
           <v-card
            outlined
            class="mb-4 vcardcontent"
            v-if="user"
          >
            <v-card-text style="color:#ffffff;" class="honeyBold">
              <v-container class="pa-0">
                <v-row>
                  <v-col>
                    <div class="bold-honey">User name:</div>
                    <div class="mt-2">{{user.userName}}</div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div class="bold-honey">Name:</div>
                    <div class="mt-2">{{user.firstName}} {{user.surname}}</div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div class="bold-honey">Email:</div>
                    <div class="mt-2">{{user.email}}</div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div class="bold-honey">Notifications:</div>
                    <div class="mt-2">
                      <v-icon
                        left
                        dark
                        color="red"
                        v-if="!user.receiveCompetitionNotifications"
                      >
                        mdi-close-circle
                      </v-icon>
                      <v-icon
                        left
                        dark
                        color="green"
                        v-if="user.receiveCompetitionNotifications"
                      >
                        mdi-check-circle
                      </v-icon> Receive competition notifications
                    </div>
                    <div class="mt-1">
                      <v-icon
                        left
                        dark
                        color="red"
                        v-if="!user.receiveMarketingMessages"
                      >
                        mdi-close-circle
                      </v-icon>
                      <v-icon
                        left
                        dark
                        color="green"
                        v-if="user.receiveMarketingMessages"
                      >
                        mdi-check-circle
                      </v-icon> Receive marketing messages
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <router-link :to="{name: 'edit-profile'}">Edit profile</router-link>
        </v-col>
        <v-col class="text-right">
          <router-link :to="{name: 'change-password'}">Change password</router-link>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <router-link :to="{name: 'logout'}">Log Out</router-link>
        </v-col>
        <v-col class="text-right danger-link">
          <a @click="dialogCloseAccount = true;">Close Account</a>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="dialogCloseAccount"
      scrollable
      overlay-opacity="0.9"
    >
      <v-card>
        <v-card-title>Close Account</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="color:#ffffff;" class="honeyBold">
          <p>
            Are you sure you want to close your account?
          </p>
          <p>
            We sorry to see you go! To confirm this action, please click the button below. Your account closure should take place within the next 48 hours.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="fanhiveHoney"
            text
            @click="dialogCloseAccount = false"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="fanhiveHoney"
            @click="closeAccount"
            style="color: #ffffff !important;border: 1px solid #ffb300;"
          >
            Confirm Closure
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Spinner :overlay="overlay"></Spinner>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import Spinner from './../../components/Spinner';

export default {
  name: 'profile',
  components: {
    PageHeader,
    Spinner
  },
  data: () => ({
    overlay: false,
    user: null,
    dialogCloseAccount: false
  }),
  methods: {
    getUser: function () {
      var scope = this;
      this.overlay = true;
      this.$store.dispatch('getUser', this.$store.getters.userSub.id).then(response => {
        scope.user = response;
        scope.overlay = false;
      }, error => {
          scope.overlay = false;
          console.log(error);
      });
    },
    closeAccount: function () {
      var scope = this;
      scope.dialogCloseAccount = false;
      scope.overlay = true;
      scope.$store.dispatch('addInternal', {
        action: "CLOSEACCOUNT"
      }).then(() => {
        scope.overlay = false;
        scope.$router.push({name: 'logout'});
      }, error => {
          console.log(error);
      });
    }
  },
  created () {
    this.getUser();
  }
}
</script>